import Tile from "../../../Components/Tiles/Tile";
import { CompanyReference, Validation } from "../../../system/Domain";
import axios, { AxiosResponse } from "axios";
import parseContentDispositionFilename from "../../../system/parseContentDispositionFilename";
import fileDownload from "js-file-download";
import { CloudDownload } from "@mui/icons-material";
import List from "../../../Components/List";
import ListItem from "../../../Components/ListItem";
import ListItemAction from "../../../Components/ListItemAction";
import ListItemActions from "../../../Components/ListItemActions";
import ListItemContent from "../../../Components/ListItemContent";
import TextBlock from "../../../Components/Layout/TextBlock";
import ListItemChips from "../../../Components/ListItemChips";
import ListItemChip from "../../../Components/ListItemChip";
import formatDateTime from "../../../system/formatDateTime";

interface Props {
	validation: Validation
	assignedTo: CompanyReference
}

const ValidationDocuments = (props: Props) => {
	const handleDownloadFile = async (id: string) => {
		if (!id) return;

		const response = await axios.get<Blob>(`/api/storage/${id}`, {
			responseType: "blob"
		});

		handleDownload(response);
	};

	const handleDownload = (response: AxiosResponse<Blob>) => {
		const filename = parseContentDispositionFilename(response.headers["content-disposition"]);

		fileDownload(response.data, filename);
	};

	return (
		<Tile title="Validationsdokumente" sxProp={{ mb: 2 }}>
			<List>
				<ListItem>
					<ListItemActions>
						<ListItemAction
							icon={<CloudDownload />}
							onClick={() => handleDownloadFile(props.validation.validationDocumentUpload.storageFile.hash)}
						/>
					</ListItemActions>
					<ListItemContent>
						<TextBlock
							primary="Validierungsergebnis"
							secondary={formatDateTime(props.validation.validationDocumentUpload.storageFile.date)}
						/>
						<ListItemChips>
							{props.assignedTo && (
								<ListItemChip
									label={props.assignedTo.name}
									color="primary"
								/>
							)}
							<ListItemChip
								label="DMS Übertrag"
								color="error"
							/>
						</ListItemChips>
					</ListItemContent>
				</ListItem>
			</List>
		</Tile>
	);
};

export default ValidationDocuments;
